// extracted by mini-css-extract-plugin
module.exports = {"identity-info":"identityInfo_identity-info__1R_sQ"};